import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IPostComments } from 'src/app/models/notice-board';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor, VisitorStatusTimeline } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-visitor-timeline-graph-container',
  templateUrl: './visitor-timeline-graph-container.component.html',
  styleUrl: './visitor-timeline-graph-container.component.scss',
})
export class VisitorTimelineGraphContainerComponent {
  @Input() set visitorData(val: Visitor) {
    if (val) {
      this.visitorGraph = val.visitorTimelineGraph;
      this.visitorDetails = val;
      this.visitorComments = val.visitorComments;
    }
  }
  @Input() orgUsersData: UserRegDetails[];
  @Input() isGraph: boolean = false;
  @Input() selectedCommentId: string = null;

  @Output() closeVisitorDetail = new EventEmitter<boolean>();
  @Output() postVisitorComment = new EventEmitter<any>();
  screenSize: ScreenType;
  visitorGraph: VisitorStatusTimeline[];
  visitorComments: IPostComments[];
  visitorDetails: Visitor;
  constructor(private screen: AumyeResponsiveScreenService) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onClose() {
    this.closeVisitorDetail.emit();
  }
  onPostInidentComment(val: any) {
    this.postVisitorComment.emit(val);
  }
  ScreenType = ScreenType;
}
